<template>
  <form>
    <h2>{{ $t('Add.Media.MediaQueries') }}</h2>
    <p class="note">{{ $t('Add.Media.Note1') }}</p>
    <div class="divider">
      <label class="contentLabel" for="mediaQueries">{{ $t('Add.Media.MediaQueries') }}</label>
      <codemirror
        class="codeEditor"
        v-model="localMediaQueries"
        placeholder="Enter your media queries here..."
        :extensions="extensions"
        style="margin-top: 5px; height: 200px"
      />
    </div>
    <button @click.prevent="openModal = true" class="open"><span class="material-symbols-outlined">fullscreen</span></button>
    <EditorModal 
      v-if="openModal" :code=localMediaQueries
      :isOpen="openModal" 
      :editorMode="'css'"
      @close="openModal = false"
      @updateCode="updateLocalMediaQueries"
      />
    <button type="button" class="save" @click.prevent="updateMediaQueries"> {{ $t('Add.Media.Save') }}
    </button>
    <div class="bottomDivider">
    <p>{{ $t('Add.Media.ColorMode') }}</p>
    <p class="note noteS">{{ $t('Add.Media.Note2') }} </p>
  <div class="button-group" >
    <div 
      class="deviceButton modeLight" 
      :class="{ active: colorMode == 'light' }" 
      @click="setColorMode('light')"
    >
      <span class="material-icons">light_mode</span>
  </div>
    <div 
      class="deviceButton modeDark" 
      :class="{ active: colorMode == 'dark' }" 
      @click="setColorMode('dark')"
    >
      <span class="material-icons">dark_mode</span>
    </div>
  </div>
</div>
  </form>
</template>


<script>
import { Codemirror } from 'vue-codemirror';
import { mapState, mapMutations } from 'vuex';
import { css } from "@codemirror/lang-css";
import { EditorView } from '@codemirror/view';
import EditorModal from '../Reusables/EditorModal.vue'

export default {
name: 'AddMedia',
components: {
  Codemirror,  EditorModal
},
data() {
  return {
    extensions: [
      css(),  
      EditorView.lineWrapping],
    localMediaQueries: '', // Lokale Kopie für die Eingabe
    openModal: false
  };
},
computed: {
  ...mapState(['mediaQueries', 'cssClasses', 'colorMode']),
},
watch: {
  // Aktualisiert die lokale Kopie, wenn sich der state im Store ändert
  mediaQueries(newVal) {
    this.localMediaQueries = newVal;
  }
},
methods: {
  ...mapMutations(['setMediaQueries', 'setColorMode']),
  updateMediaQueries() {
    this.setMediaQueries(this.localMediaQueries);
  },
  toggleSection(section) {
    if (this.activeSections.includes(section)) {
      // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
      this.activeSections = this.activeSections.filter(s => s !== section);
    } else {
      // Abschnitt hinzufügen
      this.activeSections.push(section);
    }
  },
  isSectionActive(section) {
    return this.activeSections.includes(section);
  },
  updateLocalMediaQueries(contents){
    this.localMediaQueries = contents
  }
},
mounted() {
  // Initialisiere die lokale Kopie
  this.localMediaQueries = this.mediaQueries;
  console.log(this.cssClasses)
},
};
</script>


<style scoped>
form {
font-family: 'Montserrat', sans-serif;
padding-top: 5px;
}

.note {
font-size: 14px;
margin-bottom: 20px;
color: #666;
font-style: italic;
}

.noteS {
font-size: 12px;
}

form {
text-align: left;
padding-left: 20px;
padding-right: 20px;
}

.open{
cursor: pointer;
background: none;
border: none;
padding: 0;
cursor: pointer;
text-align: right;
margin-top: 10px;
}

.open:focus {
outline: none;
}

.save{
float: right;
margin-top: 10px;
font-family: "Montserrat", sans-serif;
font-size: 16px;
border: 1px solid #ccc;
border-radius: 4px;
cursor: pointer;
background: white;
transition: background-color 0.3s;
}

.save:hover {
background: rgb(241, 238, 238);
}

.button-group {
display: flex;
align-items: center;
}

.deviceButton {
flex: 1;
padding: 5px;
text-align: center;
cursor: pointer;
border: 1px solid #ccc;
transition: background-color 0.3s;
}

.deviceButton:hover {
background: rgb(241, 238, 238);
}

.deviceButton.active {
background-color: #eeeeee;
}

.modeLight{
border-top-left-radius: 15px;
border-bottom-left-radius: 15px;
border-right: none;
}

.modeDark {
border-top-right-radius: 15px;
border-bottom-right-radius: 15px;
}

.bottomDivider{
margin-top: 60px;
}
</style> 